import React from 'react'
import { Icon } from '@drifthq/tide-core'
import { isNil } from 'ramda'
import cx from 'classnames'
import { Switch, Route, Redirect } from 'react-router-dom'

import GetStartedCard from 'components/GetStartedCard'
import SignupChoiceCard from 'layouts/SignupChoiceCard'
import SignupCard from 'layouts/SignupCard'
import FindMyTeamVerify from 'layouts/FindMyTeam/FindMyTeamVerify'
import FindMyTeamEmailSent from 'layouts/FindMyTeam/FindMyTeamEmailSent'

import { Flow } from 'constants/flowConstants'

import './style.css'

const LANGUAGES = [
  {text: 'Hello!', language: 'english'},
  {text: 'Hola!', language: 'spanish'},
  {text: 'Olá', language: 'portuguese'},
  {text: 'Hei!', language: 'norwegian'},
  {text: 'Привет', language: 'russian'},
  {text: 'नमस्ते', language: 'hindi'},
  {text: '你好', language: 'chinese'},
  {text: 'Halo', language: 'indonesian'},
]

const TouchlessStart = ({
  search,
  displayChatNumber,
  interactiveColor,
  onValueChange,
  loginUrl,
  flow
}) => {
  return (
    <div className={"setup-container touchless-start-container"}>
      <div className={"touchless-start-background touchless-start-background-size"}/>
      {!isNil(displayChatNumber) &&
        <div
          key={displayChatNumber}
          className={cx(
            'touchless-start-speech-button',
            LANGUAGES[displayChatNumber].language,
            { 'interactive-color': interactiveColor }
          )}
        >
          {LANGUAGES[displayChatNumber].text}
        </div>
      }
      <div className="setup-container-fields touchless-start-fields">
        <div className="touchless-start-container-elements">
          <div className="touchless-start-logo-container">
            <Icon className="touchless-start-drift-logo" name="drift-logo-round"/>
          </div>
          <Switch>
            <Route path="/start/video" render={() => <Redirect to="/video/start"/>}/>
            <Route path="/start/findTeam/verify" component={FindMyTeamVerify}/>
            <Route path="/start/findTeam/sent" component={FindMyTeamEmailSent}/>
            <Route path="/start/signup" render={() => <SignupCard onValueChange={onValueChange}/>}/>
            <Route path="/start/select" component={SignupChoiceCard}/>
            <Route path="/start" component={GetStartedCard}/>
          </Switch>
        </div>
        {flow !== Flow.HYFY_MIGRATION && <p className="touchless-start-fields-link">
          Already have a Drift account?
          <a
            className="touchless-start-link"
            href={loginUrl}
          >
            Sign In
          </a>
        </p>}
      </div>
    </div>
  )
}

export default TouchlessStart



// WEBPACK FOOTER //
// ./src/layouts/TouchlessStart/component.js